<ion-grid *ngIf="options.length > 0">
  <ion-row>
    <ion-col size="12">
      <p class="instructions-title">{{ text }}</p>
    </ion-col>

    <ion-col class="options" size="12">
      <ion-row>
        <ion-tab-button
          *ngFor="let item of options"
          (click)="goToOption(item, $event)"
          [ngClass]="{
            selected: gameType === 'sorteo' ? item.path === selected : item.path === 'manual',
            auto: options.length === 1
          }"
        >
          <ion-icon [name]="item.icon.name" [src]="item.icon.src"></ion-icon>
          <ion-label translate>{{ item.name }}</ion-label>
        </ion-tab-button>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>
